var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3v36.003a3 3 0 004.342 2.683l36.002-18a3 3 0 000-5.367L4.342.317A3 3 0 000 3.001z",
    opacity: 0.9
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MiA0MiI+CiAgICA8cGF0aCBkPSJNMCAzdjM2LjAwM2EzIDMgMCAwIDAgNC4zNDIgMi42ODNsMzYuMDAyLTE4YTMgMyAwIDAgMCAwLTUuMzY3TDQuMzQyLjMxN0EzIDMgMCAwIDAgMCAzLjAwMXoiIG9wYWNpdHk9Ii45IiAvPgo8L3N2Zz4K";
export { SvgPlay as ReactComponent };